import Vue from 'vue';

export default {
  popup: (text) => {
    if (!text.response) {
      Vue.prototype.$toastr('error', 'Serwer nie odpowiada. Spróbuj za chwile. Jeśli problem się powtórzy to skontaktuj się z administratorem');
      return;
    }
    const data = text.response.data || {};
    const msg = data.error || data.message;
    if (msg) {
      Vue.prototype.$toastr('error', msg);
    } else if (text.response.status === 500) {
      Vue.prototype.$toastr('error', 'Wystąpił błąd z serwerem. Spróbuj ponownie');
    } else {
      Vue.prototype.$toastr('error', 'Błąd komunikacji z serwerem');
    }
  },
  success: (message) => {
    Vue.prototype.$toastr('success', message);
  },
};
